// src/components/Report/shared/ChartCard.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { hex2rgba } from "./reportUtils";

/**
 * Card wrapper for any chart/panel in the report grid.
 * Handles the title/subtitle header, top accent gradient, and the
 * "locked until you select something" overlay used throughout the reports.
 */
export default function ChartCard({
  title, subtitle, height = 200, accent, children,
  locked, lockMsg, delay = 0, fullRow,
}) {
  return (
    <motion.div
      className={`dlg-card${fullRow ? " dlg-full-row" : ""}`}
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut", delay }}
    >
      {accent && (
        <div
          className="dlg-card-accent"
          style={{ background: `linear-gradient(90deg,${accent},${hex2rgba(accent, 0)})` }}
        />
      )}
      <div className="dlg-card-header">
        <div className="dlg-card-title">{title}</div>
        <div className="dlg-card-sub">{subtitle}</div>
      </div>
      <div className="dlg-card-body" style={{ height, position: "relative" }}>
        {children}
      </div>
      <AnimatePresence>
        {locked && (
          <motion.div
            className="dlg-card-lock-overlay"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          >
            <div className="dlg-lock-icon">📊</div>
            <span className="dlg-lock-title">Select a subject</span>
            <span className="dlg-lock-msg">{lockMsg}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}